module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [_c(_vm.currentView, {
    tag: "component",
    on: {
      "viewChanged": function($event) {
        _vm.currentView = $event
      }
    }
  })], 1), _vm._v(" "), _c('app-dialog'), _vm._v(" "), _c('app-loading'), _vm._v(" "), _c('app-snackbar'), _vm._v(" "), _c('app-toast')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e24fd7b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 230
// module chunks = 0